import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getSettingFaireDirectWidgetInstallationSelfServe } from "@faire/help-center-utils/settings/getSettingFaireDirectWidgetInstallationSelfServe";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Link } from "@faire/web--source/slate/icons/foundation/Link";
import React from "react";

import { OTHER_NODES_LABEL } from "../../shared/other-node";
import { SelfServeNode, SelfServeNodes } from "../../types";
import { FaireDirectWidgetIA } from "../instantAnswers/faireDirect-faireDirectWidget";

export const useFaireDirectBrandNodes = (): SelfServeNodes => {
  const { strictLocalize } = useStrictLocalization();
  const articles = useArticles();

  const commonFields: SelfServeNode = {
    id: "FaireDirect",
    label: strictLocalize({
      defaultMessage: "Faire Direct",
      description: {
        text: "A top level issue node in the full page self-serve experience of Faire's Help Center",
      },
    }),
    icon: <Link fontSize="24px" color="faireBlack" />,
    level: 1,
    sidebarTitle: strictLocalize({
      defaultMessage: "Faire Direct issue",
      description: {
        text: "Title for displaying the issue on the order summary sidebar",
      },
    }),
  };

  if (getSettingFaireDirectWidgetInstallationSelfServe()) {
    return {
      FaireDirect: {
        ...commonFields,
        children: ["FaireDirectWidgetChat", "OtherFaireDirect"],
      },
      FaireDirectWidgetChat: {
        id: "FaireDirectWidgetChat",
        label: strictLocalize({
          defaultMessage: "Faire Direct widget",
          description: {
            text: "Title of the Faire Direct widget page",
            img: "https://cdn.faire.com/fastly/b5f748aa53fb864b9f1ccad8bcd1498a23774663cafa186ffb60c47bfe67b5bc.png",
          },
        }),
        articles: [
          articles.FaireDirect.WIDGET_GENERAL,
          articles.FaireDirect.WIDGET_SHOPIFY,
          articles.FaireDirect.WIDGET_WOOCOMMERCE,
          articles.FaireDirect.WIDGET_PRESTASHOP,
        ],
        instantAnswer: FaireDirectWidgetIA(strictLocalize),
        level: 2,
      },
      OtherFaireDirect: {
        id: "OtherFaireDirect",
        label: OTHER_NODES_LABEL(strictLocalize),
        articles: [
          articles.FaireDirect.ORDER_COMMISSION,
          articles.FaireDirect.FAIRE_DIRECT,
          articles.FaireDirect.FD_ELIGIBLE,
          articles.FaireDirect.FD_LINK,
        ],
        level: 2,
      },
    };
  }

  return {
    FaireDirect: {
      ...commonFields,
      articles: [
        articles.FaireDirect.ORDER_COMMISSION,
        articles.FaireDirect.FAIRE_DIRECT,
        articles.FaireDirect.FD_ELIGIBLE,
        articles.FaireDirect.FD_LINK,
      ],
    },
  };
};
